import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { WebsiteScrapeState } from "@/types/websiteScrape";

import { websiteScrapeApi } from "./websiteScrape.api";

const initialState: WebsiteScrapeState = {
	credits: 0,
};

export const websiteScrapeSlice = createSlice({
	name: "websiteScrape",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			websiteScrapeApi.endpoints.getWebsiteScrapeCredits.matchFulfilled,
			(state, { payload }) => {
				state.credits = payload.credits;
			}
		);
	},
});

export const websiteScrapeReducer = websiteScrapeSlice.reducer;
export const websiteScrapeSelector = (state: RootState) => state[websiteScrapeSlice.name];
